import React from 'react';
import styled from 'styled-components';
import Error from './Error';
import { marketplaceInputStyles } from './Common';

const Textarea = ({ label, name, onChange, value, error }) => {
  const handleChange = ({ target }) => {
    onChange(name, target.value);
  };

  return (
    <Wrapper>
      <StyledTextarea
        name={name}
        value={value}
        onChange={handleChange}
        textarea
        placeholder={label}
      />
      {error && <Error>{error}</Error>}
    </Wrapper>
  );
};

export default Textarea;

const Wrapper = styled.label`
  display: block;
  position: relative;
`;

interface StyledTextareaProps {
  textarea?: boolean;
  onFocus?: any;
  onBlur?: any;
}

const StyledTextarea = styled.textarea<StyledTextareaProps>`
  ${marketplaceInputStyles}
  font-family: 'PT Sans', sans-serif;
  width: 100%;
  height: 80px;
  resize: none;
`;
